// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","productCard":"products-card_productCard__VhbPv","opened":"products-card_opened__2a79V","showDetails":"products-card_showDetails__++Em9"};